import axios from 'axios'
import { openPage } from '@/tool/util'
import { getToken,LoginOut } from '@/tool/common'
import { Modal } from 'ant-design-vue'
import baseconfig from '../../baseconfig'

const service = axios.create({
    baseURL: HostConfig.Api + baseconfig.module,
    timeout: 15000,
    headers: {"Content-Type": "application/json;charset=UTF-8"},
    transformRequest: [
        function(data, headers) {
            var token = getToken()
            if (token) headers['Authorization'] = token
            return data
        }
    ],
    withCredentials: false, //允许跨域请求
})

service.interceptors.request.use(function (config) {
    config.data = JSON.stringify(config.data)
    return config;
}, function (error) {
    return Promise.reject(error);
});


// 添加响应拦截器
service.interceptors.response.use(function (response) {
    const result = response.data
    if(result.code == 50001 || result.code == 50002) {
        Modal.error({
            content: result.message,
            onOk(){
                // 执行登出 事件
                LoginOut()
                openPage({url: "/login"})
            }
        })
        return false;
    }
    return result;
}, function (error) {
    console.log(error)
    if(error.message == "timeout of 15000ms exceeded") {
        Modal.error({
            title: '提示',
            content: "网络连接超时",
        })
        return
    }
    if(error.message == "Network Error") {
        Modal.error({
            title: '提示',
            content: "网络连接错误",
        })
        return
    }
    if(error.response.status == 404) {
        Modal.error({
            title: '提示',
            content: "接口不存在",
        })
        return
    }
    if(error.response.status == 500) {
        Modal.error({
            title: '服务器错误',
            content: error.response.data.message,
        })
        return
    }
    return Promise.reject(error);
});

export default service